import { render } from "./MNavItem.vue?vue&type=template&id=64b1adcc&scoped=true"
import script from "./MNavItem.vue?vue&type=script&lang=ts"
export * from "./MNavItem.vue?vue&type=script&lang=ts"

import "./MNavItem.vue?vue&type=style&index=0&id=64b1adcc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-64b1adcc"

export default script